

import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../services/api";
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.min.css";

function LogsReportPage() {
  const [agents, setAgents] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [bhrName, setbhrName] = useState("");
  const [loading, setLoading] = useState(false);
  const [extraPdf, setExtraPdf] = useState(null);
  const [message, setMessage] = useState("");
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [searchQuery, setSearchQuery] = useState("");

  const navigate = useNavigate();
  const imageRef = useRef(null);
  const cropper = useRef(null);
  const finalBlob = useRef(null);

  const role = localStorage.getItem("role");
  const isbhr = role === "bhr";

  useEffect(() => {
    const handleMouseMove = (e) => setMousePos({ x: e.clientX, y: e.clientY });
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (selectedAgent && imageRef.current && !cropper.current && imageRef.current.src) {
      cropper.current = new Cropper(imageRef.current, {
        aspectRatio: 3,
        viewMode: 1,
        background: false,
        responsive: true,
      });
    }
    return () => {
      if (cropper.current) {
        cropper.current.destroy();
        cropper.current = null;
      }
    };
  }, [selectedAgent]);


  const filteredAgents = agents.filter((agent) => {
    const term = searchQuery.toLowerCase();
    return (
      agent.name?.toLowerCase().includes(term) ||
      agent.comm_code?.toLowerCase().includes(term) ||
      agent.email?.toLowerCase().includes(term) ||
      agent.mobile?.toLowerCase().includes(term)
    );
  });


  const handleReject = async (id) => {
    const reason = prompt("Enter reject reason:");

    if (!reason) return;

    try {
      const formData = new FormData();
      formData.append("reason", reason);

      await API.post(`logs/bhr/reject/${id}`, formData);

      alert("Rejected successfully");
      window.location.reload();

    } catch (err) {
      console.error(err);
      alert("Error rejecting");
    }
  };

  const fetchData = async () => {
    try {
      const res = await API.get("/logs/signed");
      setAgents(res.data || []);
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setMessage("");
    const url = URL.createObjectURL(file);

    if (imageRef.current) {
      imageRef.current.src = url;
      imageRef.current.style.display = "block";
      if (cropper.current) cropper.current.destroy();
      cropper.current = new Cropper(imageRef.current, {
        aspectRatio: 3,
        viewMode: 1,
        background: false,
      });
    }
  };

  const cropImage = () => {
    if (!cropper.current) return;
    const canvas = cropper.current.getCroppedCanvas({
      width: 500,
      height: 180,
      fillColor: "transparent",
    });



    const ctx = canvas.getContext("2d");
    const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imgData.data;

    for (let i = 0; i < data.length; i += 4) {
      const r = data[i], g = data[i + 1], b = data[i + 2];
      const brightness = (r + g + b) / 3;
      const isBlueInk = b > r + 5 && b > g + 5;

      if (isBlueInk && brightness < 220) {
        data[i] = 5; data[i + 1] = 20; data[i + 2] = 90;
        let pressure = Math.pow((255 - brightness) / 255, 0.8) * 255;
        data[i + 3] = Math.min(255, pressure + 40);
      } else {
        data[i + 3] = 0;
      }
    }

    ctx.putImageData(imgData, 0, 0);
    canvas.toBlob((blob) => { finalBlob.current = blob; }, "image/png");
    imageRef.current.src = canvas.toDataURL("image/png");
    if (cropper.current) cropper.current.destroy();
    setMessage("✅ Signature cleaned & ready");
  };



  // ✅ ensure path exists
  const fileUrl = selectedAgent?.pdf
    ? `https://vgmconsult.net/api/files/${selectedAgent.pdf.split("/").pop()}`
    : null;

  console.log("SELECTED AGENT:", selectedAgent);

  console.log("FILE URL:", fileUrl);

  const handleApprove = async () => {
    if (!bhrName || !finalBlob.current) {
      alert("Enter BHR name and crop signature first");
      return;
    }
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("bhr_name", bhrName);
      formData.append("file", finalBlob.current, "signature.png");

      if (extraPdf) {
        formData.append("extra_pdf", extraPdf);
      }

      await API.post(`/logs/approve/${selectedAgent.id}`, formData);
      alert("✅ Approved Successfully");
      setSelectedAgent(null);
      setbhrName("");
      finalBlob.current = null;
      fetchData();
    } catch (err) {
      alert(err.response?.data?.detail || "❌ Failed to approve");
    } finally {
      setLoading(false);
    }
  };

  const isSelectedAgentApproved = selectedAgent && (selectedAgent.status === "bhr_approved" || selectedAgent.status === "approved");

  return (
    <div className="logs-report-wrapper">
      <style>{`
        .logs-report-wrapper {
          min-height: 100vh; background: #020617; color: white;
          font-family: 'Plus Jakarta Sans', sans-serif; padding: 40px 20px;
        }
        .spotlight {
          position: fixed; top: 0; left: 0; width: 100%; height: 100%;
          background: radial-gradient(circle at ${mousePos.x}px ${mousePos.y}px, rgba(59, 130, 246, 0.07) 0%, transparent 50%);
          z-index: 1; pointer-events: none;
        }
        .container { max-width: 1300px; margin: 0 auto; position: relative; z-index: 2; }
        .logs-header { text-align: center; margin-bottom: 40px; }
        .logs-header h1 { 
          font-size: 32px; font-weight: 800; 
          background: linear-gradient(to right, #fff, #94a3b8);
          -webkit-background-clip: text; -webkit-text-fill-color: transparent;
        }

        /* --- 🔍 SEARCH STYLING --- */
        .search-container {
          margin-bottom: 30px;
          display: flex;
          justify-content: center;
        }
        .search-input {
          width: 100%;
          max-width: 600px;
          background: rgba(255, 255, 255, 0.03);
          border: 1px solid rgba(255, 255, 255, 0.1);
          padding: 16px 24px;
          border-radius: 16px;
          color: white;
          font-size: 15px;
          outline: none;
          transition: 0.3s;
          backdrop-filter: blur(10px);
        }
        .search-input:focus {
          border-color: #3b82f6;
          background: rgba(255, 255, 255, 0.06);
          box-shadow: 0 0 20px rgba(59, 130, 246, 0.15);
        }

        .glass-card {
          background: rgba(255, 255, 255, 0.02); backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.08); border-radius: 24px; padding: 20px;
          overflow-x: auto;
        }

        .back-btn-fixed {
          position: fixed; bottom: 20px; left: 20px;
          padding: 0 16px; height: 45px;
          width:20rem;
          background: rgba(255, 255, 255, 0.05); backdrop-filter: blur(12px);
          border: 1px solid rgba(255, 255, 255, 0.1); color: #94a3b8;
          border-radius: 12px; cursor: pointer; z-index: 100; 
          transition: all 0.3s ease; display: flex; align-items: center; gap: 8px;
          font-weight: 600; font-size: 14px;
        }
        .back-btn-fixed:hover { background: rgba(255, 255, 255, 0.1); color: white; transform: translateY(-3px); }

        .logs-table { width: 100%; border-collapse: separate; border-spacing: 0 8px; }
        .logs-table th { padding: 15px; text-align: left; color: #64748b; font-size: 12px; text-transform: uppercase; }
        .logs-table td { padding: 16px; background: rgba(255, 255, 255, 0.03); font-size: 14px; }
        .logs-table td:first-child { border-radius: 12px 0 0 12px; }
        .logs-table td:last-child { border-radius: 0 12px 12px 0; }
        .status { padding: 4px 10px; border-radius: 6px; font-size: 11px; font-weight: 700; text-transform: uppercase; }
        .status.signed { background: rgba(59, 130, 246, 0.1); color: #3b82f6; }
        .status.bhr_approved, .status.approved { background: rgba(34, 197, 94, 0.1); color: #22c55e; }

        .btn.approve {
          background: #fbbf24; color: #020617; border: none; padding: 8px 16px;
          border-radius: 10px; font-weight: 700; cursor: pointer; transition: 0.2s;
        }

        .fullscreen-modal {
          position: fixed; top: 0; left: 0; width: 100%; height: 100%;
          background: #020617; z-index: 1000; display: flex; flex-direction: column;
        }
        .fs-header { padding: 20px 40px; display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid rgba(255,255,255,0.1); }
        .fs-body { display: grid; grid-template-columns: 1fr 400px; flex: 1; overflow: hidden; }
        .fs-pdf { background: #1e293b; padding: 20px; }
        .fs-pdf iframe { width: 100%; height: 100%; border-radius: 12px; border: none; }
        
        .fs-side {
          padding: 40px; border-left: 1px solid rgba(255,255,255,0.1);
          overflow-y: auto; background: rgba(255,255,255,0.01);
        }
        .fs-side h3 { margin-bottom: 20px; color: #fbbf24; }
        .fs-side input[type="text"] {
          width: 100%; background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1);
          padding: 12px; border-radius: 12px; color: white; margin-bottom: 20px;
        }

        .img-wrapper { 
          background: #000; border-radius: 12px; margin-bottom: 15px; 
          min-height: 150px; display: flex; align-items: center; justify-content: center;
          border: 1px dashed rgba(255,255,255,0.2);
        }
        .preview-img { max-width: 100%; border-radius: 8px; }
        
        .approve-btn {
          width: 100%; padding: 16px; border-radius: 14px; border: none;
          background: #22c55e; color: #020617; font-weight: 800; cursor: pointer; margin-top: 20px;
        }
        .approve-btn:disabled { opacity: 0.5; cursor: not-allowed; }
        .close-btn { background: none; border: none; color: white; font-size: 24px; cursor: pointer; }
      `}</style>

      <div className="spotlight"></div>

      <button className="back-btn-fixed" onClick={() => navigate("/dashboard")}>
        <span>←</span> <span>Dashboard</span>
      </button>

      <div className="container">
        <header className="logs-header">
          <h1>📄 Signed Agents Report</h1>
          <p>Verify documents and provide BHR final approval</p>
        </header>


        {/* 🔍 Search Input Field */}
        <div className="search-container">
          <input
            type="text"
            className="search-input"
            placeholder="Search by name, comm code, email or contact..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>


        <div className="glass-card">
          <table className="logs-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Status</th>
                <th>Sent Date</th>
                <th>Submission</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredAgents.length === 0 ? (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center", padding: '60px', color: '#64748b' }}>
                    {agents.length === 0 ? "No signed records found." : "No records match your search."}
                  </td>
                </tr>
              ) : (
                filteredAgents.map((a) => {
                  const isRowApproved = a.status === "bhr_approved" || a.status === "approved";
                  const isbhr = role === "bhr";
                  return (
                    <tr key={a.id}>
                      <td style={{ fontWeight: '600' }}>{a.name}</td>
                      <td style={{ color: '#94a3b8' }}>{a.email}</td>
                      <td><span className={`status ${a.status}`}>{a.status?.replace('_', ' ')}</span></td>
                      <td>{a.sending_time ? new Date(a.sending_time).toLocaleDateString() : "-"}</td>
                      <td>{a.submission_time ? new Date(a.submission_time).toLocaleDateString() : "Not Submitted"}</td>
                      <td>
                        <button
                          className="btn approve"
                          onClick={() => setSelectedAgent(a)}
                          disabled={
                            !isbhr ||
                            isRowApproved ||
                            a.status === "bhr_rejected" ||   // ✅ NEW
                            a.status === "admin_rejected"    // ✅ NEW
                          }
                          style={{
                            opacity:
                              !isbhr ||
                                isRowApproved ||
                                a.status === "bhr_rejected" ||
                                a.status === "admin_rejected"
                                ? 0.5
                                : 1
                          }}
                        >
                          {a.status === "bhr_rejected" || a.status === "admin_rejected"
                            ? "❌ Rejected"
                            : isRowApproved
                              ? "✔ Approved"
                              : !isbhr
                                ? "🔒 BHR Only"
                                : "✅ Review"}
                        </button>


                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>

      {selectedAgent !== null && (
        <div className="fullscreen-modal">
          <div className="fs-header">
            <h2>Reviewing: {selectedAgent.name}</h2>
            <button className="close-btn" onClick={() => setSelectedAgent(null)}>✕</button>
          </div>

          <div className="fs-body">
            <div className="fs-pdf">
              {fileUrl ? (
                <iframe
                  src={fileUrl}
                  title="PDF Preview"
                  style={{ width: "100%", height: "100%", border: "none" }}
                />
              ) : (
                <div style={{ textAlign: 'center', color: '#ef4444', marginTop: '20%' }}>
                  PDF File Not Found
                </div>
              )}
            </div>

            <div className="fs-side">
              <h3>BHR Final Authorization</h3>
              <p style={{ fontSize: '13px', color: '#94a3b8', marginBottom: '20px' }}>
                Please provide your full name and digital signature to finalize this agreement.
              </p>

              <input
                type="text"
                placeholder="Full BHR Name"
                value={bhrName}
                onChange={(e) => setbhrName(e.target.value)}
              />

              <label style={{ display: 'block', fontSize: '12px', color: '#64748b', marginBottom: '8px' }}>
                Upload Signature Photo
              </label>
              <input type="file" accept="image/*" onChange={handleFileChange} style={{ marginBottom: '15px' }} />

              <label style={{ fontSize: "12px", color: "#64748b" }}>
                Upload Final PDF (Optional)
              </label>

              <input
                type="file"
                accept="application/pdf"
                onChange={(e) => setExtraPdf(e.target.files[0])}
                style={{ marginBottom: "15px" }}
              />

              <div className="img-wrapper">
                <img ref={imageRef} className="preview-img" alt="" style={{ display: 'none' }} />
              </div>

              <button style={{
                width: '100%', padding: '12px', borderRadius: '10px', background: 'rgba(255,255,255,0.05)',
                color: 'white', border: '1px solid rgba(255,255,255,0.1)', cursor: 'pointer'
              }} onClick={cropImage}>
                ✂ Crop & Clean Signature
              </button>

              <button
                className="approve-btn"
                onClick={handleApprove}
                disabled={loading || isSelectedAgentApproved || role !== "bhr"}
              >
                {loading ? "Authorizing..." : isSelectedAgentApproved ? "✔ Already Approved" : "✔ Final Approve & Close"}
              </button>

              <button
                onClick={() => handleReject(selectedAgent.id)}
                disabled={
                  !isbhr ||
                  selectedAgent.status === "bhr_approved" ||
                  selectedAgent.status === "bhr_rejected" ||
                  selectedAgent.status === "admin_approved" ||
                  selectedAgent.status === "admin_rejected"
                }
                style={{
                  opacity:
                    !isbhr ||
                      selectedAgent.status === "bhr_approved" ||
                      selectedAgent.status === "bhr_rejected" ||
                      selectedAgent.status === "admin_approved" ||
                      selectedAgent.status === "admin_rejected"
                      ? 0.5
                      : 1
                }}
              >
                {!isbhr
                  ? "🔒 BHR Only"
                  : selectedAgent.status === "bhr_rejected" || selectedAgent.status === "admin_rejected"
                    ? "❌ Rejected"
                    : "❌ Reject"}
              </button>



              {message && <p className="message" style={{ textAlign: 'center', marginTop: '15px', color: '#22c55e' }}>{message}</p>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default LogsReportPage;